<div data-cy="iot-platform-ui-date-interval-field" fxLayout="row wrap" style="max-width: 30rem !important; display: flex; align-items: center">
  <iot-platform-ui-date-range
    (dateRangeChange)="onDateRangeChange($event)"
    [clearDateRangeFilters$]="clearDateRangeFilters$"
    [dateFormatterPattern]="$safeNavigationMigration(data()?.dateFormatterPattern)"
    fxFlex="90%"
    data-cy="iot-platform-ui-date-interval-field-date-range"
    toggleIcon="arrow_drop_down"
    placeholderClear="FILTER_ENGINE.CLEAR"
    placeholderFrom="FILTER_ENGINE.DATE_PLACEHOLDER_FROM"
    placeholderHours="FILTER_ENGINE.DATE_PLACEHOLDER_HOURS"
    placeholderMinutes="FILTER_ENGINE.DATE_PLACEHOLDER_MINUTES"
    placeholderTo="FILTER_ENGINE.DATE_PLACEHOLDER_TO"
  />
  <button
    fxFlex="10%"
    (click)="onValidation()"
    [disabled]="disabled() || (!startDate && !endDate)"
    color="accent"
    data-cy="iot-platform-ui-date-interval-field-add-btn"
    mat-icon-button
  >
    <mat-icon>add_circle</mat-icon>
  </button>
</div>
